"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendJSError = void 0;

var sendJSError = function sendJSError(processName, method, data) {
  try {
    var dataToSend = JSON.stringify(data);

    if (window.IC && window.IC.trackErrorCtz) {
      window.IC.trackErrorCtz(processName, '', method, dataToSend);
    }
  } catch (err) {
    console.log('IC is not defined');
  }
};

exports.sendJSError = sendJSError;

//# sourceMappingURL=index.js.map